"use client";

import { ReactNode } from "react";
import { Route } from "next";
import Image from "next/image";
import { motion } from "framer-motion";
import classNames from "classnames";
import Link from "next/link";

const Header = ({
  title,
  description,
  img,
  button,
}: {
  title: string;
  description: ReactNode;
  img: string;
  button?: {
    title: string;
    href: Route;
  };
}) => {
  return (
    <header className="mt-26 px-6 md:h-screen md:max-h-[700px]">
      <div className="mx-auto grid h-full max-w-[1440px] gap-6 md:grid-cols-2">
        <motion.div
          className="bg-secondary-light flex flex-col items-start justify-center gap-6 rounded-3xl px-4 py-10 text-lg transition-colors duration-700 md:px-10 md:text-xl"
          animate={{
            opacity: 1,
            transition: {
              duration: 0.6,
            },
          }}
          initial={{
            opacity: 0,
          }}
        >
          <h1 className="text-5xl md:text-6xl">{title}</h1>
          <div className={classNames(["leading-relaxed", !!button && "mb-4"])}>
            {description}
          </div>
          {!!button && (
            <Link href={button.href} className="button-base group">
              <div className="button-decor" />
              {button.title}
            </Link>
          )}
        </motion.div>
        <motion.div
          className="relative h-60 overflow-hidden rounded-3xl sm:h-72 md:h-auto"
          animate={{
            opacity: 1,
            transition: {
              duration: 0.6,
              delay: 0.6,
            },
          }}
          initial={{
            opacity: 0,
          }}
        >
          <Image src={img} alt="" fill className="object-cover" />
        </motion.div>{" "}
      </div>
    </header>
  );
};

export default Header;
